import { Button, Card, CardContent, Chip, Grid, Typography } from "@mui/material";
import { cloneDeep } from "lodash";
import React, { useEffect, useState } from "react";
import Api from "../../Api";
import { Feature, PermissionContext } from "../../contexts/PermissionContext";
import { IAssignedMaterial, IDispatchMaterialGroup, IItemValidationModel, IMaterialFulfillmentFormSection } from "../../interfaces";
import { Format } from "../../utils/Format";
import { MaterialDispatchFormControl } from "../Shared/FormControls/MaterialDispatchFormControl";
import { FormSectionHeader } from "../Shared/FormSectionHeader";

export const MaterialFulfillmentForm: React.FC<IMaterialFulfillmentFormSection> = ({
    dispatchRequestId,
    materialGroups,
    assignedMaterial,
    onUpdateMaterials,
    readonly,
    saving,
    ...props
}: IMaterialFulfillmentFormSection) => {



    const permissionContext = React.useContext(PermissionContext);

    const [assigned, setAssigned] = useState<IItemValidationModel[]>([]);

    const handleAdjustQuantity = (requestedItem: IDispatchMaterialGroup, materialId: string | undefined, subtract: boolean = false) => {
        let assignedMaterials = cloneDeep(assignedMaterial);
        let updated = false;

        if (assignedMaterials) {
            assignedMaterials.forEach(item => {

                if (item.itemId === requestedItem.id) {

                    console.log("identified target", item);

                    item.materials.forEach(material => {

                        if (material.id === materialId) {



                            if (subtract) material.quantity = material.quantity === 0 ? 0 : (material.quantity - 1);
                            else {

                                let max = requestedItem.materialGroup.materials?.filter(x => x.materialId === materialId)[0].quantity;

                                if (material.quantity !== max)
                                    material.quantity++;
                            };

                            updated = true;
                        }
                    });


                    if (!updated)
                        item.materials.push({ id: materialId ?? "", quantity: subtract ? 0 : 1 })

                    //check if we have valid fulfillment for this item
                    let currGroup = materialGroups.filter(x => x.id == item.itemId)[0];
                    item.fulfilled = item.materials.reduce((sum, x) => sum + x.quantity, 0) === currGroup.requestedQuantity;
                }
            });

            setAssigned(assignedMaterials);

            onUpdateMaterials(assignedMaterials);
        }
    }
    const handleSetQuantity = (requestedItem: IDispatchMaterialGroup, materialId: string | undefined, qty: number) => {

        let assignedMaterials = cloneDeep(assigned);
        let updated = false;

        assignedMaterials.forEach(item => {

            if (item.itemId === requestedItem.id) {




                let max = requestedItem.materialGroup.materials?.filter(x => x.materialId === materialId)[0].quantity ?? 0;

                if (qty > max) qty = max;


                item.materials.forEach(material => {
                    if (material.id === materialId) {
                        material.quantity = qty;
                        updated = true;
                    }
                })


                if (!updated)
                    item.materials.push({ id: materialId ?? "", quantity: qty })

                //check if we have valid fulfillment for this item
                let currGroup = materialGroups.filter(x => x.id == item.itemId)[0];
                item.fulfilled = item.materials.reduce((sum, x) => sum + x.quantity, 0) === currGroup.requestedQuantity;
            }

        });

        setAssigned(assignedMaterials);

        onUpdateMaterials(assignedMaterials);

    }

    const isValid = (dmg: IDispatchMaterialGroup, materials: IAssignedMaterial[]) => {
        let validState = false;

        let assignedQty = materials.reduce((acc, obj) => { return acc + obj.quantity }, 0);
        if (assignedQty === dmg.requestedQuantity) validState = true;

        return validState;
    }

    const handlePicklist = () => {
        Api.Dispatches.picklist(dispatchRequestId)
            .then((response: any) => response.blob())
            .then((blob) => {

                const filename = `Pick List - ${new Date().toUTCString()}.pdf`;

                const url = window.URL.createObjectURL(
                    new Blob([blob]),
                );

                const link: HTMLAnchorElement = document.createElement('a');

                link.href = url;
                link.setAttribute(
                    'download',
                    filename,
                );
                document.body.appendChild(link);
                link.click();
                link.parentNode?.removeChild(link);
            });
    }

    const totalValue = materialGroups?.reduce((acc, x) => acc + (x.valueOnDispatch || 0), 0);

    useEffect(() => {
        if (assigned.length === 0) {
            let initAssigned: IItemValidationModel[] = assignedMaterial ?? [];
            if (materialGroups && materialGroups.length > 0) {
                materialGroups.forEach(g => {
                    if (!initAssigned.some(x => x.itemId === g.id))
                        initAssigned.push({
                            itemId: g.id,
                            materials: [],
                            fulfilled: false
                        })
                });

                onUpdateMaterials(initAssigned);
                setAssigned(initAssigned);
            }
        }
    }, [materialGroups])

    return (
        <Card>

            <FormSectionHeader label="Requested Materials" saving={saving} />

            <CardContent>

                <Grid container spacing={4}>

                    {(materialGroups && materialGroups.length > 0) ?
                        <Grid xs={12} item>
                            {materialGroups?.map(requestedItem => {

                                let assignedMaterials = assigned?.filter(x => x.itemId === requestedItem.id)[0]?.materials ?? []

                                return (<MaterialDispatchFormControl
                                    key={requestedItem.id}
                                    requestedItem={requestedItem}
                                    assigned={assignedMaterials}
                                    valid={isValid(requestedItem, assignedMaterials)}
                                    onAdjustQuantity={(m, s) => handleAdjustQuantity(requestedItem, m, s)}
                                    onSetQuantity={(m, q) => handleSetQuantity(requestedItem, m, q)}
                                    readonly={readonly}
                                    saving={saving}
                                />);
                            })}
                        </Grid>
                        :
                        <Grid item xs={12}>
                            <Typography
                                sx={{ pb: 2 }}
                                variant="subtitle2"
                            >
                                This dispatch request currently contains no materialGroups.
                            </Typography>
                        </Grid>
                    }

                    <Grid item>
                        {permissionContext.isPermitted(Feature.DispatchRequest_Picklist)
                            &&
                            <Button variant="outlined"
                                onClick={handlePicklist}
                            >Pick List</Button>
                        }

                        {totalValue > 0 &&
                            <Chip
                                sx={{ ml: 1 }}
                                color="info"
                                label={"Total £" + Format.currency(totalValue)} />
                        }
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    );
}